export default __webpack_public_path__ + "static/graph-one-fe7b60896b1071915ea80bcc32b96c39.png";